import React from 'react';
import { Icon } from 'infl-icons';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import cn from 'classnames';

import { messageCount } from '../../common/api';
import { qaSel } from '../../common/utils';
import { trackC2Event } from '../../common/tracking-utils';
import NotificationOverlay from '../notification-overlay';
import Points from '../points';
import { UnreadMarker } from '../unread-marker';
import styles from './style.css';

const overlayAdjustments = { leftOffset: -142, arrowOffset: 148 };

const trackClick = type => () => trackC2Event(type);

const inboxMessageEvent = 'influitive:inbox-messages-count';

const ActionCenter = compose(
  withState('msgCount', 'msgCountReceived', 0),
  withState('notificationsSeen', 'setNotificationsSeen', false),
  withHandlers({
    getMessageCount: props => () => {
      messageCount().then(count => {
        props.msgCountReceived(count.data.attributes['unread-conversation-count']);
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.getMessageCount();
      window.document.addEventListener(inboxMessageEvent, this.props.getMessageCount);
    },
    componentWillUnmount() {
      window.document.removeEventListener(inboxMessageEvent, this.props.getMessageCount);
    }
  })
)(({ points, msgCount, notificationsSeen, setNotificationsSeen, moment, unseenNotificationsCount }) => (
  <div data-qa={qaSel('action-center')} className={cn(styles.container, 'c-action-center')}>
    <NotificationOverlay
      moment={moment}
      overlayAdjustments={overlayAdjustments}
      toggleSeen={() => setNotificationsSeen(true)}>
      {!notificationsSeen && <UnreadMarker show={unseenNotificationsCount > 0} />}
      <div className={cn(styles.iconStyled, 'c-icon-wrapper')}><Icon icon="bell" /></div>
    </NotificationOverlay>
    <a
      data-qa={qaSel('link-messages')}
      className={cn(styles.iconLink, 'c-link c-message')}
      href="/inbox"
      aria-label="Access your messages">
      <UnreadMarker show={msgCount > 0} />
      <div className={cn(styles.iconStyled, 'c-icon-wrapper')}><Icon icon="mail" /></div>
    </a>
    <Points value={points} onClick={trackClick('Advocate_Navbar_Rewards')} />
  </div>
));

export default ActionCenter;
